import { Config } from '../Types/config';

export const config: Config = {
    // apiUrl: 'https://api.diagra.ru',
    apiUrl: 'https://api-diagra.cloud521.ru',
}
